import React,{Component} from 'react';
import i18n from '../../i18n';
import {Toast} from '@react/react-spectrum/Toast';
import moment from 'moment';
import 'moment/min/locales';


class I2TBanner extends Component{	
	render(){

		moment.locale(this.props.locale);
		this.props.bannerDetails.localisedDate = moment(this.props.date).format('LL')

        return(
        	<Toast className="i2tbanner">
        		{(this.props.bannerDetails.refundAmount !== 0) && i18n.t(this.props.workFlowId+'.approvalHeaderInfo.I2TBannerMessage',this.props.bannerDetails)}
                {(this.props.bannerDetails.refundAmount === 0) && i18n.t(this.props.workFlowId+'.approvalHeaderInfo.I2TBannerMessageWithRefundZero')}
            </Toast>
        )
    }
}

export default I2TBanner;